module.exports = {
      id: "vikatanspl-usage",
      viewBox: "0 0 30.9 32",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#vikatanspl",
      toString: function () {
        return this.url;
      }
    }